import { Checkbox } from "@/components/ui/checkbox";
import { ReactNode } from "react";

type CheckboxItemPropsType = {
  label: string | ReactNode;
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};
/**
 * Props type definition for the CheckboxItem component.
 * @typedef {Object} CheckboxItemPropsType
 * @property {string} label - The text for the checkbox label.
 * @property {string} id - The unique identifier for the checkbox, used for the HTML `id` attribute and label association.
 * @property {boolean} checked - Indicates if the checkbox is currently checked.
 * @property {(checked: boolean) => void} onChange - Callback function triggered on checkbox state change.
 */

/**
 * Renders a checkbox with a label, styled using Tailwind CSS.
 *
 * @param {CheckboxItemPropsType} props - The properties passed to the component, destructured in the function signature.
 * @param {string} props.label - The text for the checkbox label.
 * @param {string} props.id - The unique identifier for the checkbox, used for the HTML `id` attribute and label association.
 * @param {boolean} props.checked - Indicates if the checkbox is currently checked.
 * @param {(checked: boolean) => void} props.onChange - Callback function triggered on checkbox state change.
 * @returns {JSX.Element} A flex container with a checkbox and a label element.
 */
function CheckboxItem({ label, id, checked, onChange }: CheckboxItemPropsType) {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox id={id} checked={checked} onCheckedChange={onChange} />
      <label
        htmlFor="terms"
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
        {label}
      </label>
    </div>
  );
}

export default CheckboxItem;
